<template lang="pug">
    .z-big-select(ref="parent" v-bind:class="{'focus': focus, 'no-label' : ($props.label ? false : true), 'has-value': $props.value, 'has-error': error && error.length, 'disabled': $props.disabled, 'readonly': $props.readonly}")
        .z-big-select-container(v-on:click="onFocus" v-bind:class="{'active': focus}")
            .icon(v-html="$props.icon")
            .z-big-select-label-container
                label.z-big-select-label(v-bind:class="{'has-value': (displayLabel) ? true : false}") {{$props.label}}
                label.z-big-select-display-label {{displayLabel}}
            .z-big-select-input.can-scroll
                slot
            .z-big-select__arrow
                i.fas.fa-chevron-down
            .z-big-select__clear(v-on:click="clear")
                i.fas.fa-times
            input(
                ref="input"
                v-model="val"
                v-bind:id="$props.id"
                v-bind:name="$props.name"
                v-bind:required="$props.required"
                v-bind:disabled="$props.disabled"
                v-bind:readonly="$props.readonly"
                type="hidden"
            )
        span.z-error(v-if="error") {{error}}
</template>
<script>
    export default {
        name: 'z-big-select',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-input'
            },
            name: {
                type: String,
                default: 'z-input'
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number, Boolean],
                default: () => ''
            },
            icon: {
                type: String,
                default: '<i class="fab fa-accessible-icon"></i>'
            },
        },
        data() {
            return {
                focus: false,
                val: '',
                displayLabel: null,
            }
        },
        created() {
            if (this.$props.value) {
                this.val = this.$props.value;
                this.setLabel();
            }
        },
        mounted() {
            if (this.$props.value) {
                this.val = this.$props.value;
                this.setLabel();
            }
        },
        watch: {
            'value'(value, old) {
                if (this.val != value) {
                    this.val = value;
                    this.setLabel();
                }
            }
        },
        computed: {},
        methods: {
            listeners() {
                this.blurListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.parent && !this.$refs.parent.contains(e.target)) this.onBlur();
                });
            },
            setLabel() {
                if (this.$children) {
                    this.displayLabel = null;
                    this.$children.map(item => {
                        if (item.value == this.val) {
                            this.displayLabel = item.label;
                        }
                    });
                }
            },
            onFocus(e) {
                if (!e.target.getAttribute('data-isitem')) {
                    if (this.focus) this.onBlur();
                    else {
                        if (this.$props.disabled) return;
                        this.listeners();
                        this.focus = true;
                        this.$emit('focus');
                    }
                }
            },
            clear(e) {
                if (e) e.stopPropagation();
                this.displayLabel = null;
                this.val = null;
                this.$emit('input', this.val);
            },
            onBlur() {
                document.removeEventListener('click', this.blurListener, false);
                this.focus = false;
                this.$emit('blur');
            },
            select(label, value) {
                this.displayLabel = label;
                this.$emit('input', value);
                this.onBlur();
            }
        }
    }
</script>
<style lang="sass">
    .z-big-select
        margin: 4px 0 10px 0
        position: relative
        &.disabled
            .z-big-select-container
                background: #eee
                .z-big-select-label
                    width: calc(100% - 35px)
            .z-big-select__arrow
                display: none
            .z-big-select__clear
                display: none
        .z-big-select-container
            display: flex
            align-items: center
            justify-content: flex-start
            height: 50px
            background: #FFFFFF
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2)
            border-radius: 3px
            padding: 10px
            .z-big-select-label-container
                display: flex
                flex-direction: column
                width: calc(100% - 90px)
                font-size: 14px
                line-height: 14px
                align-items: flex-start
                justify-content: center
                .z-big-select-display-label, .z-big-select-label
                    width: 100%
                    white-space: nowrap
                    overflow: hidden
                    text-overflow: ellipsis
                .z-big-select-label.has-value
                    color: #7b7b7b
                    margin: 0 0 4px 0
                    font-size: 12px
                    line-height: 12px
            .icon
                font-size: 22px
                width: 24px
                height: 22px
                color: #000
                margin: 0 10px 0 0
                svg
                    width: 24px
            .z-big-select-input
                display: none
            &.active
                .z-big-select-input
                    display: block
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding-top: 4px
            color: #ff1744
        label
        select
            font-size: 14px
            line-height: 24px
            border: none
            background: #fff
            outline: none
            color: #000
            font-weight: 400
            height: 26px
            width: 100%
            position: relative
            z-index: 10
            -webkit-appearance: none !important
        .error
        .z-big-select-input
            position: absolute
            top: 40px
            padding: 10px 0
            width: 100%
            left: 0
            right: 0
            z-index: 101
            background: #FFFFFF
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)
            border-radius: 3px
            border-top-left-radius: 0
            border-top-right-radius: 0
            max-height: 250px
            overflow-y: auto
        .z-big-select__arrow, .z-big-select__clear
            position: absolute
            z-index: 1
            right: 10px
            font-size: 16px
            width: 20px
            height: 20px
            border-radius: 100%
            display: flex
            align-items: center
            justify-content: center
        .z-big-select__clear
            right: 35px
            cursor: pointer
            &:hover
                background: #e4e4e4
            &:active
                background: #d3d3d3
    .z-big-select.has-error
        label   
            color: #ff1744
        .z-big-select-container
            &::after
                background-color: #ff1744
            &::before
                background-color: #ff1744
    .z-big-select.focus
        label
        .z-big-select-container
            &::after
                
            &::before
                
    .z-big-select.disabled
        select
            background: #eaeaea
    .z-big-select.readonly
        select
            background: #eaeaea                
</style>


// WEBPACK FOOTER //
// ZBigSelect.vue?2cc12bee